import * as React from 'react';

/** Material UI Packages. */
import { Slide } from '@mui/material';

/** Component for dialog transition animations. */
export const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
